// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3WJd_","containerItemsCenter":"Skeleton_containerItemsCenter__k01lx"};